import React from 'react';

import { ToasterService } from '~commonInfra/services/ToasterService';
import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';
import { ConnectedStartersSpace } from './ConnectedStartersSpace';

export interface StartersSpaceProviderProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
  readonly urls: SpacesSiteUrls;
  readonly connectionType?: string;
}

const StartersSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'starters',
  subspaceName: undefined
};

export const StartersSpaceProvider: React.FunctionComponent<StartersSpaceProviderProps> = (props) => {

  return (
    <ConnectedSpaceInfoProvider spaceInfo={StartersSpaceInfo}>
      <ConnectedStartersSpace  sessionManagementService={getSessionManagementServiceInstance()}
        toasterService={ToasterService.instance} urls={props.urls} selectedConnectionTypeInternalName={props.connectionType}/>
    </ConnectedSpaceInfoProvider>
  );
};
